import { render, staticRenderFns } from "./THGUserForm.vue?vue&type=template&id=22fe8c82&scoped=true"
import script from "./THGUserForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGUserForm.vue?vue&type=style&index=0&id=22fe8c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe8c82",
  null
  
)

export default component.exports